import { Grid, Typography } from '@material-ui/core'
import { FC } from 'react'
// import { ResponseT } from '../../../services/um/useExternalResearcher'
import CardItem from './CardItem'

import useTranslate from '../../../../../i18n/useTranslate'
import { TReturnList } from '../searchType'
import { Button } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import useLoadingStore from '../../../../../control/loading/store/useLoadingStore'

interface ResultProps {
    onClickEdit: (itm: any) => void
    onClickCreate: () => void
    pendingProps: any
    data: TReturnList[]
    isResearcher?: boolean
    isSumItem?: number
}
const Result: FC<ResultProps> = ({ onClickEdit, onClickCreate, data, isResearcher, isSumItem, pendingProps }) => {
    const translate = useTranslate()
    const loadingStore = useLoadingStore()

    return (
        <Grid container spacing={2}>
            {/* <Grid item xs={12}>
                <Typography variant="h6">{translate.get('LABEL.SEARCH_TOTAL_RESULT', [`${data.length}`])}</Typography>
            </Grid> */}

            <Grid item xs={12}>
                <Grid container justify="space-between" alignItems="center" style={{ margin: '18px 0px ' }}>
                    <Typography variant="h6">{translate.get('LABEL.SEARCH_TOTAL_RESULT', [`${isSumItem}`])}</Typography>

                    {isResearcher && (
                        <Grid item xs={12} sm={4} md={4} lg={4}>
                            <Grid container justify="flex-end">
                                <Button
                                    size="large"
                                    variant="outlined"
                                    color="primary"
                                    startIcon={<AddIcon />}
                                    onClick={onClickCreate}
                                >
                                    <Typography variant="button">{translate.get('LABEL.ADD_PROJECT')}</Typography>
                                </Button>
                            </Grid>
                        </Grid>
                    )}
                </Grid>
            </Grid>

            <Grid item xs={12}>
                {data.map((item, i) => {
                    return (
                        <Grid item xs={12} key={`${item.projectID}-${item.submittedID}-${i}`}>
                            <CardItem pendingProps={pendingProps} data={item} onClickEdit={onClickEdit} />
                        </Grid>
                    )
                })}
            </Grid>

            {!loadingStore.isLoading && data?.length === 0 && (
                <Grid
                    container
                    item
                    alignContent="center"
                    justify="center"
                    style={{ border: '1px solid rgba(0, 0, 0, .125)', marginBottom: 60 }}
                >
                    <Typography variant="h6">{translate.get('LABEL.NO_DATA_FOUND')}</Typography>
                </Grid>
            )}
        </Grid>
    )
}

export default Result
